import { render, staticRenderFns } from "./AddSenderID.vue?vue&type=template&id=5527b30e&scoped=true"
import script from "./AddSenderID.vue?vue&type=script&lang=js"
export * from "./AddSenderID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527b30e",
  null
  
)

export default component.exports